module.exports = __webpack_public_path__ + "static/media/header-image.76d1383d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-image.png
// module id = 1101
// module chunks = 0